import React from "react"
import { Route, Redirect } from "react-router-dom"
import { connect } from "react-redux"
import { ROUTES } from "../../common/utils"

class Auth extends React.Component {
  isLoggedIn = () => {
    return this.props.hasUserInStore
  }

  isUnsubscribed = () => {
    // Let through if loggin out
    const availableRoutes = [
      ROUTES.LOGOUT,
      ROUTES.TRIAL_EXPIRY,
      ROUTES.SUBSCRIPTION_PAYMENT,
      ROUTES.SUBSCRIPTION_RETURN,
      ROUTES.SUBSCRIPTION_CANCEL
    ]
    if (availableRoutes.includes(this.props.path)) return false
    return this.props.isUnsubscribed
  }

  render() {
    const { component: Component, ...rest } = this.props
    console.log("isUnsubscribed: ", this.isUnsubscribed())
    console.log("isExpired: ", this.props.isExpired)
    console.log("isLoggedIn: ", this.isLoggedIn())
    return (
      <Route
        {...rest}
        render={props =>
          this.isLoggedIn() ? (
            this.isUnsubscribed() ? (
              <Redirect
                to={{
                  pathname: this.props.isExpired
                    ? ROUTES.FREE_TRIAL_LINK
                    : ROUTES.REACTIVATE,
                  state: { from: props.location }
                }}
              />
            ) : (
              <Component {...props} />
            )
          ) : (
            <Redirect
              to={{
                pathname: "/login",
                state: { from: props.location }
              }}
            />
          )
        }
      />
    )
  }
}

const mapStateToProps = ({ user }) => {
  console.log("User in Auth: ", user)
  return {
    hasUserInStore:
      user.token && user.token !== null && user.token !== "" ? true : false,
    isUnsubscribed:
      user.account &&
      user.account.status &&
      (user.account.status.toLowerCase() === "unsubscribed" ||
        user.account.status.toLowerCase() === "unpaid"),
    isExpired:
      user.account &&
      user.account.status &&
      user.account.status.toLowerCase() === "expired"
  }
}

export default connect(mapStateToProps)(Auth)
